import type { CSSProperties, ElementType, ReactNode } from 'react'

import { useInView } from '@/hooks/use-in-view'

interface FadeInProps {
    children: ReactNode
    as?: 'div' | 'section' | 'article' | 'li' | 'figure' | 'aside' | 'span' | 'p'
    className?: string
    delay?: number
    trigger?: 'mount' | 'view'
}

const FadeIn = ({ children, as = 'div', className, delay = 0, trigger = 'view' }: FadeInProps): ReactNode => {
    const Component = as as ElementType
    const { ref, inView } = useInView<HTMLElement>()
    const state = trigger === 'mount' || inView ? 'play' : 'wait'

    return (
        <Component
            ref={ref}
            className={className}
            data-fade={state}
            style={{ '--d': `${delay}s` } as CSSProperties}
        >
            {children}
        </Component>
    )
}

export default FadeIn
